<ca-clickable-link [innerHtml]="message" (linkClicked)="onLinkClicked()"></ca-clickable-link>
